<template>

<div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Create Student Account</a>

    </h1>
    

<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Create Student Account</div> 
<div class="panal-body">
    <b-row>
 <b-col sm=12 lg="3"> <div style="font-size:11rem !important;vertical-align: top;height:40px;line-height: 0;"> <b-icon icon="person-fill" >
     </b-icon></div></b-col>
    <b-col class="mt-4" sm=12 lg="3"> 
    <b-form-input v-model="firstname" :placeholder="firstname"  disabled></b-form-input>
    </b-col>
    <b-col class="mt-4" sm=12 lg="3"><b-form-select v-model="selected" :options="Names" ></b-form-select></b-col>
     <b-col sm=12 lg="3">
          <b-form-input v-model="nums[0]" :placeholder="nums[0]" class="col-2  float-left mr-1 mt-4" maxlength="1" ></b-form-input> 
          <b-form-input v-model="nums[1]" :placeholder="nums[1]" class="col-2  float-left mr-1 mt-4" maxlength="1" ></b-form-input> 
          <b-form-input v-model="nums[2]" :placeholder="nums[2]" class="col-2  float-left mr-1 mt-4" maxlength="1"></b-form-input> 
          <b-form-input v-model="nums[3]" :placeholder="nums[3]" class="col-2  float-left mr-1 mt-4" maxlength="1" ></b-form-input> 
          <b-form-input v-model="nums[4]" :placeholder="nums[4]" class="col-2  float-left mt-4" maxlength="1"></b-form-input> 

     </b-col>
    </b-row>
    <b-row class="mt-4" >
        <b-col> <h5 class="text-center"> Generated Email :  {{generatedEmail}}</h5></b-col></b-row>
    <b-row>
        <b-col class="text-center mt-4"> <button  type="submit" class="btn btn-primary text-center" @click="Validate">Validate Email </button>
        </b-col>

    </b-row>
    <b-row>
        <b-col class="text-center mt-4">
            <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
 </b-col>

    </b-row>
    <b-row v-if="isValid">
        <div class="col-12 col-md-6 mb-1">
              

<b-form-group id="input-group-1" label="Your Password:" label-for="input-1">
            <password v-model="password" :show-password="show" :badge="false" :toggle="true" class="su-border"/>

        

 </b-form-group>
 
            </div>
            <div class="col-6 mt-4 mb-1 align">
                <button type="button" class="btn btn-success" @click="createAccount">Create account</button>
            </div>
 

    </b-row>



</div>
</div>
</div>
</div>



</div>
</template>
<script>
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services';
import Password from "vue-password-strength-meter";

    export default {
        name: 'CreateStudentAccount',
        components:{
            Password
        },
        data() {
      return {
        selected: '',
        Names: [],
        firstname : '',
        nums:[],
        message: '',
        successful :'',
        isValid:false,
        password:null,
        show: false,
        code : ''
      }
        },
        mounted(){
           this.firstname = this.currentUser.FirstNameEN.split(' ').join('')
           this.Names.push(this.currentUser.SecondNameEN.split(' ').join(''))
           this.Names.push(this.currentUser.ThirdNameEN.split(' ').join(''))
           this.Names.push(this.currentUser.FamilyNameEN.split(' ').join(''))
           this.Names.push(this.currentUser.LastNameEN.split(' ').join(''))
           this.code =JSON.parse( localStorage.student )[0]
          
           let lastDigit =   this.code.StudentCode.slice(4)
           this.nums = Array.from(lastDigit)
        //    console.log(this.nums)
           this.selected = this.Names[0]
        },
        computed:{
             currentUser() {
                 return this.$store.state.auth.user;
                },
                generatedEmail(){
                    return this.firstname+'.'+this.selected+this.nums.join('')+'@su.edu.eg'
                }
                
        },methods:{
            Validate(){
                ApplicantDataServices.ValidateADEmail(this.generatedEmail).then(result=>{
                    if(result.data == false){
                            this.message= 'Email is valid'
                            this.successful =true
                            this.isValid = true
                    }
                }, error => {
                    this.isValid = false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                this.successful =false
                if(error.response.status == 404) this.message =''
                
            })
            },
            toggle () {
      this.show = !this.show
    },
    createAccount(){
        let obj = {}
            obj.Email = this.generatedEmail
            obj.StudentCode = this.code.StudentCode
            obj.FirstName = this.firstname
            obj.LastName = this.Names[this.Names.length-1]
            obj.Password = this.password
            obj.FacultyBranchID = this.code.FacultyBranchID
            obj.ApplicantID = this.code.ApplicantID

            // console.log(obj)
        ApplicantDataServices.CreateStudentEmail(obj).then(res=>{
            console.log(res.data)
        })
    }
        },
        


    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.align{
    margin-top: 32px !important
}
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #ff8600;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.Password__field{
    border: 1px solid #285475 !important;
}


@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}


</style>
